var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "dark" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-container",
            [
              _c(
                "v-btn",
                {
                  staticClass:
                    "font-weight-bold text-xs text-dark btn-light py-5 px-6 mt-6 mb-2 ms-2",
                  attrs: { ripple: false, elevation: 0 },
                  on: { click: _vm.apiSetSeedData },
                },
                [_vm._v(" Generate seeds with AI ")]
              ),
            ],
            1
          ),
          _c(
            "v-container",
            [
              _vm.seedsLoading
                ? _c(
                    "div",
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(this.seeds, function (item) {
                return _c(
                  "v-chip",
                  {
                    key: item,
                    staticClass: "my-1 mx-1",
                    attrs: { close: "", color: "blue" },
                    on: {
                      "click:close": function ($event) {
                        return _vm.removeSeed(item)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item) + " ")]
                )
              }),
            ],
            2
          ),
          _c(
            "v-container",
            [
              _c(
                "v-col",
                { attrs: { cols: "5" } },
                [
                  _c("h6", { staticClass: "text-h6" }, [
                    _vm._v("Number of seeds: " + _vm._s(this.seeds.length)),
                  ]),
                  _c("br"),
                  _c("v-text-field", {
                    attrs: { id: "seed-input", label: "Add seed manually" },
                    model: {
                      value: _vm.tmpSeed,
                      callback: function ($$v) {
                        _vm.tmpSeed = $$v
                      },
                      expression: "tmpSeed",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: !!!_vm.tmpSeed,
                    elevation: "2",
                    icon: "",
                    large: "",
                    rounded: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createSeed()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-checkbox-marked-circle")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }